import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { UploadAndReviewView } from "../components/organisms/UploadAndReviewView";
import { listActiveBusinessUnits } from "../services/businessUnitService";
import { uploadContractForReview } from "../services/uploadReviewService";
import { ApiError } from "../services/apiClient";
import type { ContractUploadDetails } from "../types/contractUploadDetails";
import type { BusinessUnitOption } from "../types/businessUnit";
import { mergeBusinessUnitOptionsFromApi } from "../utils/businessUnitApiCodes";

export const UploadAndReviewPage = () => {
  const navigate = useNavigate();
  const [businessUnitOptions, setBusinessUnitOptions] = useState<readonly BusinessUnitOption[]>([]);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    listActiveBusinessUnits()
      .then((rows) => setBusinessUnitOptions(mergeBusinessUnitOptionsFromApi(rows)))
      .catch(() => setBusinessUnitOptions([]));
  }, []);

  const handleInitiateReview = async (details: ContractUploadDetails) => {
    setSubmitError(null);
    setIsSubmitting(true);
    try {
      await uploadContractForReview({
        file: details.file,
        displayName: details.contractName,
        contractOrigination: details.contractOrigination,
        contractType: details.contractType || undefined,
        businessUnit: details.businessUnit || undefined,
      });
      navigate("/contractiq/contracts");
    } catch (err) {
      const message = err instanceof ApiError ? err.message : "Upload could not be completed.";
      setSubmitError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <UploadAndReviewView
      businessUnitOptions={businessUnitOptions}
      onInitiateReview={handleInitiateReview}
      submitError={submitError}
      isSubmitting={isSubmitting}
    />
  );
};
